import { SUPPORTED_LOCALES, DEFAULT_LOCALE } from "@/i18n";

// Parses a pathname like "/en/story" or "/story" and returns
// { locale, pathWithoutLocale } where pathWithoutLocale has no leading locale segment.
export function parseLocaleFromPath(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length > 0 && SUPPORTED_LOCALES.includes(parts[0])) {
    const locale = parts[0];
    const rest = "/" + parts.slice(1).join("/");
    return { locale, pathWithoutLocale: rest === "/" ? "/" : rest };
  }
  return { locale: DEFAULT_LOCALE, pathWithoutLocale: pathname };
}

// Build a path for a specific locale and (locale-free) target path.
// HR has no prefix; others have /<locale>.
export function localePath(locale, pathWithoutLocale) {
  const clean = pathWithoutLocale.startsWith("/") ? pathWithoutLocale : "/" + pathWithoutLocale;
  if (locale === DEFAULT_LOCALE) {
    return clean === "/" ? "/" : clean;
  }
  if (clean === "/") return `/${locale}`;
  return `/${locale}${clean}`;
}

// Hreflang URL helpers for SEO
export function buildHreflangs(currentPathname, origin) {
  const { pathWithoutLocale } = parseLocaleFromPath(currentPathname);
  return SUPPORTED_LOCALES.map((loc) => ({
    locale: loc,
    href: `${origin}${localePath(loc, pathWithoutLocale)}`,
  }));
}
